// extracted by mini-css-extract-plugin
export default {"statusWrapper":"StatusColorPoint_statusWrapper__ZGyLR","label":"StatusColorPoint_label__YFDtE","point":"StatusColorPoint_point__bToa2"};